<template>
  <div ref="intersectionContainer">
    <div slot="body">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="12"><h1>Новости</h1></el-col>
        <el-col :span="24" style="display: flex;align-items: center;">
          <el-row type="flex" class="search-container">
            <el-input
              placeholder="Поиск"
              size="small"
              v-model="search"
              @input="handleInput"
            />
            <el-button size="small" @click="searchClick">Найти</el-button>
          </el-row>
        </el-col>
        <el-col :span="12" class="m-t-15" style="text-align: right">
          <el-button size="small" @click="addNews" type="primary"
            >Добавить новость</el-button
          >
        </el-col>
      </el-row>

      <el-table
        v-if="isTableVisible"
        height="710"
        v-loading="loadingTablePagination"
        empty-text="Записи отсутствуют"
        :data="news"
        style="width: 100%"
      >
        <el-table-column label="#" prop="id"> </el-table-column>
        <el-table-column label="Дата" prop="date">
          <template slot-scope="scope">
            {{ dateReturnFormat(scope.row.date) }}
          </template>
        </el-table-column>
        <el-table-column label="Заголовок" prop="title"> </el-table-column>
        <el-table-column width="240">
          <template slot-scope="scope">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
              >
                Редактировать
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="deleteItem(scope.$index, scope.row)"
              >
                Удалить
              </el-button>
            </el-row>
          </template>
        </el-table-column>
        <template #append>
          <div ref="observerTrigger"></div>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import { dateReturnFormat } from "@/plugins/methods";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      news: [],
      loading: false,
      loadingTablePagination: false,
      error: false,
      search: "",
      currentPage: 1,
      pageSize: 20,
      observer: undefined,
      isNewsEnded: false,
      isTableVisible: true
    };
  },
  computed: {
    ...mapGetters(["getNewsList"])
  },
  mounted() {
    this.newsListLoad();
  },
  methods: {
    handleInput(value) {
      if (value === "") {
        this.searchClick();
      }
    },

    async searchClick() {
      this.isTableVisible = false;
      this.currentPage = 1;
      const result = await this.$store.dispatch("getNews", {
        skip: (this.currentPage - 1) * this.pageSize,
        take: this.pageSize,
        search: this.search
      });

      this.isTableVisible = true;
      this.isNewsEnded = result.length < this.pageSize;
      this.news = result;

      this.$nextTick(() => {
        if (result.length !== 0) {
          this.createObserver();
        }
      });
    },

    dateReturnFormat(date) {
      return dateReturnFormat(date);
    },

    async handleCurrentChange(val) {
      this.loadingTablePagination = true;
      this.error = false;

      try {
        let query = await this.$store.dispatch("getNews", {
          page: val
        });

        this.currentPage = query.page;
        this.totalPages = query.totalPages;
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }

      this.loadingTablePagination = false;
    },

    handleEdit(index, row) {
      this.$router.push({ path: "/news/edit/" + row.id });
    },

    addNews() {
      this.$router.push({ path: "/news/add" });
    },

    async deleteItem(index, row, element) {
      this.$confirm(
        `Вы действительно хотите удалить новость ?`,
        "Подтвердите действие",
        {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        }
      ).then(async () => {
        try {
          await this.$store.dispatch("newsDelete", {
            id: row.id,
            index: index
          });
        } catch (e) {
          this.$ErrorsMod(e);
        }
      });
    },

    async newsListLoad() {
      this.loading = true;
      this.error = false;

      try {
        const result = await this.$store.dispatch("getNews", {
          skip: (this.currentPage - 1) * this.pageSize,
          take: this.pageSize,
          search: this.search
        });

        this.isNewsEnded = result.length < this.pageSize;

        if (result.length !== 0) {
          this.news = result;
        }

        if (result.length !== 0) {
          this.createObserver();
        }
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      } finally {
        this.loading = false;
      }
    },

    createObserver() {
      const callback = e => {
        if (e[0].isIntersecting) {
          this.fetchNextRequests();
        }
      };
      const options = {
        root: this.$refs.intersectionContainer,
        rootMargin: "0px",
        threshold: 0
      };
      this.observer = new IntersectionObserver(callback, options);
      this.observer.observe(this.$refs.observerTrigger);
    },

    async fetchNextRequests() {
      try {
        if (!this.isNewsEnded) {
          this.currentPage++;
          const result = await this.$store.dispatch("getNews", {
            skip: (this.currentPage - 1) * this.pageSize,
            take: this.pageSize,
            search: this.search
          });

          this.isNewsEnded = result.length < this.pageSize;

          if (result.length !== 0) {
            this.news = [...this.news, ...result];
          }
        } else {
          this.unobserveIntersecting();
        }
      } catch (error) {
        this.error = this.$ErrorsMod(e);
      }
    },

    unobserveIntersecting() {
      if (this.$refs.observerTrigger) {
        this.observer.unobserve(this.$refs.observerTrigger);
      }
    }
  },
  components: {}
};
</script>

<style scoped>
.search-container {
  width: 100%;
  gap: 10px;
}
</style>
